import Machine from '../../../types/api/machine'

export default function formatMachineBrands(entity: {
    machine?: Machine
    additional_machines?: Machine[]
}): string {
    const machineNames = [
        ...(entity.machine ? [entity.machine.name.split(' ')[0]] : []),
        ...(entity.additional_machines?.map(m => m.name.split(' ')[0]) ?? []),
    ].join(', ')
    return machineNames
}
